import * as React from "react";
import "./notification.scss";
import classNames from "classnames";

interface NotificationProps {
  type: "http" | "error" | "info" | "package-error" | "info-bold";
  message: string | React.ReactNode;
  className?: string;
}

export default function Notification(props: NotificationProps): React.ReactElement<NotificationProps> {
  return (
    <span className={classNames("notification", `${props.type}-message`, props.className)}>
      {props.message}
    </span>
  );
}
